import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../../../PanelPage";
import {Messages} from "../../../../../Messages";
import {MerchantButton} from "../../../../../common/MerchantButton";
import {Router} from "../../../../../../stem-core/src/ui/Router";
import {MessageElement} from "../../../../../widget/ui/MessageElement";
import {SubscribeFlowState} from "../../../../inline-subscription/SubscribeFlowState";


export class EditSubscriptionCancelPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.editSubscriptionCancelTitle,
        };
    }

    render() {
        const subscription = SubscribeFlowState.getSubscriptionToCancel();
        const {styleSheet} = this;

        return [
            <MessageElement className={styleSheet.description} message={Messages.editSubscriptionCancelText1(
                subscription.coverage.name, subscription.formatPrice(),
                subscription.getActiveUntil().format("MMMM DD, YYYY"))} />,
            <div className={styleSheet.description}>{Messages.editSubscriptionCancelText2}</div>,
            <MerchantButton onClick={() => SubscribeFlowState.cancel(subscription)} className={styleSheet.button}>
                {Messages.editSubscriptionCancelButton}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <div onClick={() => Router.back()} className={styleSheet.secondaryButton}>{Messages.noTakeMeBack}</div>
            </div>
        ]
    }
}
